import { forwardRef, type ReactElement } from 'react';
import cx from 'clsx';
import { Input } from '#components/form-elements/input/input';
import { SearchFieldBase, type SearchFieldBaseProps } from './search-field-base';
import styles from './search-field.module.css';

export interface SearchFieldComponentProps extends Omit<
  SearchFieldBaseProps,
  | 'inputSlot'
  | 'closeIcon'
  | 'iconClassName'
  | 'closeClassName'
  | 'spinnerClassName'
  | 'rowClassName'
> {
  compact?: boolean;
  inputClassName?: string;
}

export const SearchField = forwardRef<HTMLInputElement, SearchFieldComponentProps>(
  function SearchField(
    { placeholder, className, compact, inputClassName, showLoading, ...props },
    ref
  ): ReactElement {
    return (
      <SearchFieldBase
        placeholder={placeholder}
        className={cx(className, styles.container)}
        iconClassName={styles.icon}
        closeClassName={styles.close}
        rowClassName={styles.row}
        spinnerClassName={styles.spinner}
        showLoading={showLoading}
        inputSlot={
          <Input
            autoFocus={props.autoFocus}
            className={cx(styles.input, compact && styles.compact, inputClassName)}
            data-test-search-input
            placeholder={placeholder}
            ref={ref}
          />
        }
        {...props}
      />
    );
  }
);
